import { ApiResult, HttpClient } from "../http.js";

/**
 * Mirrors the .NET `PaymentTermsPresetDto`
 * (Mesterplan.Features.Settings.PaymentTerms.PaymentTermsPresetDto).
 */
export interface PaymentTermsPresetDto {
  id: string;
  name: string;
  /** Payment-terms type discriminator. Today only "Netto". */
  type: string;
  days: number;
  isDefault: boolean;
  createdAt: string;
  updatedAt: string;
}

export interface CreatePaymentTermsPresetPayload {
  name: string;
  type: string;
  days: number;
  isDefault: boolean;
}

export interface UpdatePaymentTermsPresetPayload {
  name: string;
  type: string;
  days: number;
}

/**
 * Company-scoped payment-terms presets, served by the .NET API
 * (`/api/settings/payment-terms-presets`). Replaces the legacy Firestore
 * `COMPANIES/{companyId}/paymentTermsPresets` subcollection.
 */
export class PaymentTermsPresetsApi {
  constructor(private readonly http: HttpClient) {}

  list(): Promise<ApiResult<PaymentTermsPresetDto[]>> {
    return this.http.get<PaymentTermsPresetDto[]>(
      "/api/settings/payment-terms-presets",
    );
  }

  /** Returns the new preset's id. */
  create(
    payload: CreatePaymentTermsPresetPayload,
  ): Promise<ApiResult<string>> {
    return this.http.post<string>("/api/settings/payment-terms-presets", {
      body: payload,
    });
  }

  update(
    id: string,
    payload: UpdatePaymentTermsPresetPayload,
  ): Promise<ApiResult<void>> {
    return this.http.put<void>(
      `/api/settings/payment-terms-presets/${encodeURIComponent(id)}`,
      { body: payload },
    );
  }

  delete(id: string): Promise<ApiResult<void>> {
    return this.http.delete<void>(
      `/api/settings/payment-terms-presets/${encodeURIComponent(id)}`,
    );
  }

  /** Marks the given preset as the company default, unsetting any other. */
  setDefault(id: string): Promise<ApiResult<void>> {
    return this.http.post<void>(
      `/api/settings/payment-terms-presets/${encodeURIComponent(id)}/set-default`,
    );
  }
}
